<form [formGroup]="skillsForm" (ngSubmit)="onSubmit()">
    <div class="step-container">
        <ng-template #labelSix>Skills</ng-template>
        <div class="step-title">Skills</div>








































         <div class="col-md-" style="border-right: 1px solid;">
           
            
            <table class="table">
          

                <thead>
                    <tr>
                        <th colspan="4" class="text-center">BUSINESS, MANAGEMENT AND HR</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Management -->
                    <tr>
                        <td >Management</td>
                        <td class="text-center"><input type="radio"  id="managementBasic" value="1" formControlName="management" /></td>
                        <td class="text-center"><input type="radio"   id="managementGood" value="2" formControlName="management" /></td>
                        <td class="text-center"><input type="radio"  id="managementVeryGood" value="3" formControlName="management" /></td>
                    </tr>
                
                    <!-- Sales & Marketing -->
                    <tr>
                        <td >Sales & Marketing</td>
                        <td class="text-center"><input type="radio" id="salesMarketingBasic" value="1" formControlName="salesMarketing" /></td>
                        <td class="text-center"><input type="radio" id="salesMarketingGood" value="2" formControlName="salesMarketing" /></td>
                        <td class="text-center"><input type="radio" id="salesMarketingVeryGood" value="3" formControlName="salesMarketing" /></td>
                    </tr>
                
                    <!-- File Management -->
                    <tr>
                        <td >File Management</td>
                        <td class="text-center"><input type="radio" id="fileManagementBasic" value="1" formControlName="fileManagement" /></td>
                        <td class="text-center"><input type="radio" id="fileManagementGood" value="2" formControlName="fileManagement" /></td>
                        <td class="text-center"><input type="radio" id="fileManagementVeryGood" value="3" formControlName="fileManagement" /></td>
                    </tr>
                
                    <!-- Office Administration -->
                    <tr>
                        <td >Office Administration</td>
                        <td class="text-center"><input type="radio" id="officeAdminBasic" value="1" formControlName="officeAdmin" /></td>
                        <td class="text-center"><input type="radio" id="officeAdminGood" value="2" formControlName="officeAdmin" /></td>
                        <td class="text-center"><input type="radio" id="officeAdminVeryGood" value="3" formControlName="officeAdmin" /></td>
                    </tr>
                
                    <!-- Organizational Management -->
                    <tr>
                        <td >Organizational Management</td>
                        <td class="text-center"><input type="radio" id="orgManagementBasic" value="1" formControlName="orgManagement" /></td>
                        <td class="text-center"><input type="radio" id="orgManagementGood" value="2" formControlName="orgManagement" /></td>
                        <td class="text-center"><input type="radio" id="orgManagementVeryGood" value="3" formControlName="orgManagement" /></td>
                    </tr>
                
                    <!-- Reception -->
                    <tr>
                        <td >Reception</td>
                        <td class="text-center"><input type="radio" id="receptionBasic" value="1" formControlName="reception" /></td>
                        <td class="text-center"><input type="radio" id="receptionGood" value="2" formControlName="reception" /></td>
                        <td class="text-center"><input type="radio" id="receptionVeryGood" value="3" formControlName="reception" /></td>
                    </tr>
                
                    <!-- Human Resources -->
                    <tr>
                        <td >Human Resources</td>
                        <td class="text-center"><input type="radio" id="humanResourcesBasic" value="1" formControlName="humanResources" /></td>
                        <td class="text-center"><input type="radio" id="humanResourcesGood" value="2" formControlName="humanResources" /></td>
                        <td class="text-center"><input type="radio" id="humanResourcesVeryGood" value="3" formControlName="humanResources" /></td>
                    </tr>
                
                    <!-- Project Coordination -->
                    <tr>
                        <td >Project Coordination</td>
                        <td class="text-center"><input type="radio" id="projectCoordinationBasic" value="1" formControlName="projectCoordination" /></td>
                        <td class="text-center"><input type="radio" id="projectCoordinationGood" value="2" formControlName="projectCoordination" /></td>
                        <td class="text-center"><input type="radio" id="projectCoordinationVeryGood" value="3" formControlName="projectCoordination" /></td>
                    </tr>
                </tbody>




                <thead>
                    <tr>
                        <th colspan="4" class="text-center">ARTS</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Architecture -->
                    <tr>
                        <td >Architecture</td>
                        <td class="text-center"><input type="radio" id="architectureBasic" value="1" formControlName="architecture" /></td>
                        <td class="text-center"><input type="radio" id="architectureGood" value="2" formControlName="architecture" /></td>
                        <td class="text-center"><input type="radio" id="architectureVeryGood" value="3" formControlName="architecture" /></td>
                    </tr>
                
                    <!-- Flowers & Garlands -->
                    <tr>
                        <td >Flowers & Garlands</td>
                        <td class="text-center"><input type="radio" id="flowersGarlandsBasic" value="1" formControlName="flowersGarlands" /></td>
                        <td class="text-center"><input type="radio" id="flowersGarlandsGood" value="2" formControlName="flowersGarlands" /></td>
                        <td class="text-center"><input type="radio" id="flowersGarlandsVeryGood" value="3" formControlName="flowersGarlands" /></td>
                    </tr>
                
                    <!-- Arts & Crafts -->
                    <tr>
                        <td class="text-center">Arts & Crafts</td>
                        <td class="text-center"><input type="radio" id="artsCraftsBasic" value="1" formControlName="artsCrafts" /></td>
                        <td class="text-center"><input type="radio" id="artsCraftsGood" value="2" formControlName="artsCrafts" /></td>
                        <td class="text-center"><input type="radio" id="artsCraftsVeryGood" value="3" formControlName="artsCrafts" /></td>
                    </tr>
                
                    <!-- Music -->
                    <tr>
                        <td >Music</td>
                        <td class="text-center"><input type="radio" id="musicBasic" value="1" formControlName="music" /></td>
                        <td class="text-center"><input type="radio" id="musicGood" value="2" formControlName="music" /></td>
                        <td class="text-center"><input type="radio" id="musicVeryGood" value="3" formControlName="music" /></td>
                    </tr>
                
                    <!-- Interior Design -->
                    <tr>
                        <td >Interior Design</td>
                        <td class="text-center"><input type="radio" id="interiorDesignBasic" value="1" formControlName="interiorDesign" /></td>
                        <td class="text-center"><input type="radio" id="interiorDesignGood" value="2" formControlName="interiorDesign" /></td>
                        <td class="text-center"><input type="radio" id="interiorDesignVeryGood" value="3" formControlName="interiorDesign" /></td>
                    </tr>
                
                    <!-- Photography -->
                    <tr>
                        <td >Photography</td>
                        <td class="text-center"><input type="radio" id="photographyBasic" value="1" formControlName="photography" /></td>
                        <td class="text-center"><input type="radio" id="photographyGood" value="2" formControlName="photography" /></td>
                        <td class="text-center"><input type="radio" id="photographyVeryGood" value="3" formControlName="photography" /></td>
                    </tr>
                
                    <!-- Video & Film -->
                    <tr>
                        <td >Video & Film</td>
                        <td class="text-center"><input type="radio" id="videoFilmBasic" value="1" formControlName="videoFilm" /></td>
                        <td class="text-center"><input type="radio" id="videoFilmGood" value="2" formControlName="videoFilm" /></td>
                        <td class="text-center"><input type="radio" id="videoFilmVeryGood" value="3" formControlName="videoFilm" /></td>
                    </tr>
                
                    <!-- Sewing -->
                    <tr>
                        <td >Sewing</td>
                        <td class="text-center"><input type="radio" id="sewingBasic" value="1" formControlName="sewing" /></td>
                        <td class="text-center"><input type="radio" id="sewingGood" value="2" formControlName="sewing" /></td>
                        <td class="text-center"><input type="radio" id="sewingVeryGood" value="3" formControlName="sewing" /></td>
                    </tr>
                
                    <!-- Graphic Design -->
                    <tr>
                        <td >Graphic Design</td>
                        <td class="text-center"><input type="radio" id="graphicDesignBasic" value="1" formControlName="graphicDesign" /></td>
                        <td class="text-center"><input type="radio" id="graphicDesignGood" value="2" formControlName="graphicDesign" /></td>
                        <td class="text-center"><input type="radio" id="graphicDesignVeryGood" value="3" formControlName="graphicDesign" /></td>
                    </tr>
                </tbody>






                <thead>
                    <tr>
                        <th colspan="4" class="text-center">COMPUTER AND IT</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Data Entry -->
                    <tr>
                        <td >Data Entry</td>
                        <td class="text-center"><input type="radio" id="dataEntryBasic" value="1" formControlName="dataEntry" /></td>
                        <td class="text-center"><input type="radio" id="dataEntryGood" value="2" formControlName="dataEntry" /></td>
                        <td class="text-center"><input type="radio" id="dataEntryVeryGood" value="3" formControlName="dataEntry" /></td>
                    </tr>
                
                    <!-- Installation & Repair -->
                    <tr>
                        <td >Installation & Repair</td>
                        <td class="text-center"><input type="radio" id="installationRepairBasic" value="1" formControlName="installationRepair" /></td>
                        <td class="text-center"><input type="radio" id="installationRepairGood" value="2" formControlName="installationRepair" /></td>
                        <td class="text-center"><input type="radio" id="installationRepairVeryGood" value="3" formControlName="installationRepair" /></td>
                    </tr>
                
                    <!-- Computer Programming -->
                    <tr>
                        <td >Computer Programming</td>
                        <td class="text-center"><input type="radio" id="computerProgrammingBasic" value="1" formControlName="computerProgramming" /></td>
                        <td class="text-center"><input type="radio" id="computerProgrammingGood" value="2" formControlName="computerProgramming" /></td>
                        <td class="text-center"><input type="radio" id="computerProgrammingVeryGood" value="3" formControlName="computerProgramming" /></td>
                    </tr>
                
                    <!-- Microsoft Office -->
                    <tr>
                        <td >Microsoft Office</td>
                        <td class="text-center"><input type="radio" id="microsoftOfficeBasic" value="1" formControlName="microsoftOffice" /></td>
                        <td class="text-center"><input type="radio" id="microsoftOfficeGood" value="2" formControlName="microsoftOffice" /></td>
                        <td class="text-center"><input type="radio" id="microsoftOfficeVeryGood" value="3" formControlName="microsoftOffice" /></td>
                    </tr>
                
                    <!-- Web Development -->
                    <tr>
                        <td >Web Development</td>
                        <td class="text-center"><input type="radio" id="webDevelopmentBasic" value="1" formControlName="webDevelopment" /></td>
                        <td class="text-center"><input type="radio" id="webDevelopmentGood" value="2" formControlName="webDevelopment" /></td>
                        <td class="text-center"><input type="radio" id="webDevelopmentVeryGood" value="3" formControlName="webDevelopment" /></td>
                    </tr>
                
                    <!-- ERP -->
                    <tr>
                        <td >ERP</td>
                        <td class="text-center"><input type="radio" id="erpBasic" value="1" formControlName="erp" /></td>
                        <td class="text-center"><input type="radio" id="erpGood" value="2" formControlName="erp" /></td>
                        <td class="text-center"><input type="radio" id="erpVeryGood" value="3" formControlName="erp" /></td>
                    </tr>
                
                    <!-- Networking -->
                    <tr>
                        <td >Networking</td>
                        <td class="text-center"><input type="radio" id="networkingBasic" value="1" formControlName="networking" /></td>
                        <td class="text-center"><input type="radio" id="networkingGood" value="2" formControlName="networking" /></td>
                        <td class="text-center"><input type="radio" id="networkingVeryGood" value="3" formControlName="networking" /></td>
                    </tr>
                
                    <!-- Microsoft Access -->
                    <tr>
                        <td >Microsoft Access</td>
                        <td class="text-center"><input type="radio" id="microsoftAccessBasic" value="1" formControlName="microsoftAccess" /></td>
                        <td class="text-center"><input type="radio" id="microsoftAccessGood" value="2" formControlName="microsoftAccess" /></td>
                        <td class="text-center"><input type="radio" id="microsoftAccessVeryGood" value="3" formControlName="microsoftAccess" /></td>
                    </tr>
                
                    <!-- System Administration -->
                    <tr>
                        <td >System Administration</td>
                        <td class="text-center"><input type="radio" id="systemAdministrationBasic" value="1" formControlName="systemAdministration" /></td>
                        <td class="text-center"><input type="radio" id="systemAdministrationGood" value="2" formControlName="systemAdministration" /></td>
                        <td class="text-center"><input type="radio" id="systemAdministrationVeryGood" value="3" formControlName="systemAdministration" /></td>
                    </tr>
                
                    <!-- Typing -->
                    <tr>
                        <td >Typing</td>
                        <td class="text-center"><input type="radio" id="typingBasic" value="1" formControlName="typing" /></td>
                        <td class="text-center"><input type="radio" id="typingGood" value="2" formControlName="typing" /></td>
                        <td class="text-center"><input type="radio" id="typingVeryGood" value="3" formControlName="typing" /></td>
                    </tr>
                
                    <!-- AutoCAD -->
                    <tr>
                        <td >AutoCAD</td>
                        <td class="text-center"><input type="radio" id="autocadBasic" value="1" formControlName="autocad" /></td>
                        <td class="text-center"><input type="radio" id="autocadGood" value="2" formControlName="autocad" /></td>
                        <td class="text-center"><input type="radio" id="autocadVeryGood" value="3" formControlName="autocad" /></td>
                    </tr>
                </tbody>









                <thead>
                    <tr>
                        <th colspan="4" class="text-center">CONSTRUCTION, MAINTENANCE AND ENGINEERING</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Air Conditioning -->
                    <tr>
                        <td >Air Conditioning</td>
                        <td class="text-center"><input type="radio" id="airConditioningBasic" value="1" formControlName="airConditioning" /></td>
                        <td class="text-center"><input type="radio" id="airConditioningGood" value="2" formControlName="airConditioning" /></td>
                        <td class="text-center"><input type="radio" id="airConditioningVeryGood" value="3" formControlName="airConditioning" /></td>
                    </tr>
                
                    <!-- Carpentry -->
                    <tr>
                        <td >Carpentry</td>
                        <td class="text-center"><input type="radio" id="carpentryBasic" value="1" formControlName="carpentry" /></td>
                        <td class="text-center"><input type="radio" id="carpentryGood" value="2" formControlName="carpentry" /></td>
                        <td class="text-center"><input type="radio" id="carpentryVeryGood" value="3" formControlName="carpentry" /></td>
                    </tr>
                
                    <!-- Electrical -->
                    <tr>
                        <td >Electrical</td>
                        <td class="text-center"><input type="radio" id="electricalBasic" value="1" formControlName="electrical" /></td>
                        <td class="text-center"><input type="radio" id="electricalGood" value="2" formControlName="electrical" /></td>
                        <td class="text-center"><input type="radio" id="electricalVeryGood" value="3" formControlName="electrical" /></td>
                    </tr>
                
                    <!-- Civil Engineering -->
                    <tr>
                        <td >Civil Engineering</td>
                        <td class="text-center"><input type="radio" id="civilEngineeringBasic" value="1" formControlName="civilEngineering" /></td>
                        <td class="text-center"><input type="radio" id="civilEngineeringGood" value="2" formControlName="civilEngineering" /></td>
                        <td class="text-center"><input type="radio" id="civilEngineeringVeryGood" value="3" formControlName="civilEngineering" /></td>
                    </tr>
                
                    <!-- Mechanical Engineering -->
                    <tr>
                        <td >Mechanical Engineering</td>
                        <td class="text-center"><input type="radio" id="mechanicalEngineeringBasic" value="1" formControlName="mechanicalEngineering" /></td>
                        <td class="text-center"><input type="radio" id="mechanicalEngineeringGood" value="2" formControlName="mechanicalEngineering" /></td>
                        <td class="text-center"><input type="radio" id="mechanicalEngineeringVeryGood" value="3" formControlName="mechanicalEngineering" /></td>
                    </tr>
                
                    <!-- Electrical Engineering -->
                    <tr>
                        <td >Electrical Engineering</td>
                        <td class="text-center"><input type="radio" id="electricalEngineeringBasic" value="1" formControlName="electricalEngineering" /></td>
                        <td class="text-center"><input type="radio" id="electricalEngineeringGood" value="2" formControlName="electricalEngineering" /></td>
                        <td class="text-center"><input type="radio" id="electricalEngineeringVeryGood" value="3" formControlName="electricalEngineering" /></td>
                    </tr>
                
                    <!-- Structural Engineering -->
                    <tr>
                        <td >Structural Engineering</td>
                        <td class="text-center"><input type="radio" id="structuralEngineeringBasic" value="1" formControlName="structuralEngineering" /></td>
                        <td class="text-center"><input type="radio" id="structuralEngineeringGood" value="2" formControlName="structuralEngineering" /></td>
                        <td class="text-center"><input type="radio" id="structuralEngineeringVeryGood" value="3" formControlName="structuralEngineering" /></td>
                    </tr>
                
                    <!-- General Maintenance -->
                    <tr>
                        <td >General Maintenance</td>
                        <td class="text-center"><input type="radio" id="generalMaintenanceBasic" value="1" formControlName="generalMaintenance" /></td>
                        <td class="text-center"><input type="radio" id="generalMaintenanceGood" value="2" formControlName="generalMaintenance" /></td>
                        <td class="text-center"><input type="radio" id="generalMaintenanceVeryGood" value="3" formControlName="generalMaintenance" /></td>
                    </tr>
                
                    <!-- Heavy Equipment -->
                    <tr>
                        <td >Heavy Equipment</td>
                        <td class="text-center"><input type="radio" id="heavyEquipmentBasic" value="1" formControlName="heavyEquipment" /></td>
                        <td class="text-center"><input type="radio" id="heavyEquipmentGood" value="2" formControlName="heavyEquipment" /></td>
                        <td class="text-center"><input type="radio" id="heavyEquipmentVeryGood" value="3" formControlName="heavyEquipment" /></td>
                    </tr>
                
                    <!-- Plumbing -->
                    <tr>
                        <td >Plumbing</td>
                        <td class="text-center"><input type="radio" id="plumbingBasic" value="1" formControlName="plumbing" /></td>
                        <td class="text-center"><input type="radio" id="plumbingGood" value="2" formControlName="plumbing" /></td>
                        <td class="text-center"><input type="radio" id="plumbingVeryGood" value="3" formControlName="plumbing" /></td>
                    </tr>
                
                    <!-- Surveying -->
                    <tr>
                        <td >Surveying</td>
                        <td class="text-center"><input type="radio" id="surveyingBasic" value="1" formControlName="surveying" /></td>
                        <td class="text-center"><input type="radio" id="surveyingGood" value="2" formControlName="surveying" /></td>
                        <td class="text-center"><input type="radio" id="surveyingVeryGood" value="3" formControlName="surveying" /></td>
                    </tr>
                
                    <!-- Welding -->
                    <tr>
                        <td >Welding</td>
                        <td class="text-center"><input type="radio" id="weldingBasic" value="1" formControlName="welding" /></td>
                        <td class="text-center"><input type="radio" id="weldingGood" value="2" formControlName="welding" /></td>
                        <td class="text-center"><input type="radio" id="weldingVeryGood" value="3" formControlName="welding" /></td>
                    </tr>
                </tbody>

                







                <thead>
                    <tr>
                        <th colspan="4" class="text-center">FINANCE & LEGAL</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Legal -->
                    <tr>
                        <td >Legal</td>
                        <td class="text-center"><input type="radio" id="legalBasic" value="1" formControlName="legal" /></td>
                        <td class="text-center"><input type="radio" id="legalGood" value="2" formControlName="legal" /></td>
                        <td class="text-center"><input type="radio" id="legalVeryGood" value="3" formControlName="legal" /></td>
                    </tr>
                
                    <!-- Bookkeeping -->
                    <tr>
                        <td>Bookkeeping</td>
                        <td class="text-center"><input type="radio" id="bookkeepingBasic" value="1" formControlName="bookkeeping" /></td>
                        <td class="text-center"><input type="radio" id="bookkeepingGood" value="2" formControlName="bookkeeping" /></td>
                        <td class="text-center"><input type="radio" id="bookkeepingVeryGood" value="3" formControlName="bookkeeping" /></td>
                    </tr>
                
                    <!-- Budgeting -->
                    <tr>
                        <td >Budgeting</td>
                        <td class="text-center"><input type="radio" id="budgetingBasic" value="1" formControlName="budgeting" /></td>
                        <td class="text-center"><input type="radio" id="budgetingGood" value="2" formControlName="budgeting" /></td>
                        <td class="text-center"><input type="radio" id="budgetingVeryGood" value="3" formControlName="budgeting" /></td>
                    </tr>
                
                    <!-- Accounting -->
                    <tr>
                        <td>Accounting</td>
                        <td class="text-center"><input type="radio" id="accountingBasic" value="1" formControlName="accounting" /></td>
                        <td class="text-center"><input type="radio" id="accountingGood" value="2" formControlName="accounting" /></td>
                        <td class="text-center"><input type="radio" id="accountingVeryGood" value="3" formControlName="accounting" /></td>
                    </tr>
                
                    <!-- Cashier -->
                    <tr>
                        <td>Cashier</td>
                        <td class="text-center"><input type="radio" id="cashierBasic" value="1" formControlName="cashier" /></td>
                        <td class="text-center"><input type="radio" id="cashierGood" value="2" formControlName="cashier" /></td>
                        <td class="text-center"><input type="radio" id="cashierVeryGood" value="3" formControlName="cashier" /></td>
                    </tr>
                
                    <!-- Purchasing -->
                    <tr>
                        <td >Purchasing</td>
                        <td class="text-center"><input type="radio" id="purchasingBasic" value="1" formControlName="purchasing" /></td>
                        <td class="text-center"><input type="radio" id="purchasingGood" value="2" formControlName="purchasing" /></td>
                        <td class="text-center"><input type="radio" id="purchasingVeryGood" value="3" formControlName="purchasing" /></td>
                    </tr>
                
                    <!-- Other Finance -->
                    <tr>
                        <td >Other Finance</td>
                        <td class="text-center"><input type="radio" id="otherFinanceBasic" value="1" formControlName="otherFinance" /></td>
                        <td class="text-center"><input type="radio" id="otherFinanceGood" value="2" formControlName="otherFinance" /></td>
                        <td class="text-center"><input type="radio" id="otherFinanceVeryGood" value="3" formControlName="otherFinance" /></td>
                    </tr>
                </tbody>

                




                <thead>
                    <tr>
                        <th colspan="4" class="text-center">FOOD SERVICES</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Baking -->
                    <tr>
                        <td >Baking</td>
                        <td class="text-center"><input type="radio" id="bakingBasic" value="1" formControlName="baking" /></td>
                        <td class="text-center"><input type="radio" id="bakingGood" value="2" formControlName="baking" /></td>
                        <td class="text-center"><input type="radio" id="bakingVeryGood" value="3" formControlName="baking" /></td>
                    </tr>
                
                    <!-- Cooking -->
                    <tr>
                        <td >Cooking</td>
                        <td class="text-center"><input type="radio" id="cookingBasic" value="1" formControlName="cooking" /></td>
                        <td class="text-center"><input type="radio" id="cookingGood" value="2" formControlName="cooking" /></td>
                        <td class="text-center"><input type="radio" id="cookingVeryGood" value="3" formControlName="cooking" /></td>
                    </tr>
                
                    <!-- Restaurant Management -->
                    <tr>
                        <td >Restaurant Management</td>
                        <td class="text-center"><input type="radio" id="restaurantManagementBasic" value="1" formControlName="restaurantManagement" /></td>
                        <td class="text-center"><input type="radio" id="restaurantManagementGood" value="2" formControlName="restaurantManagement" /></td>
                        <td class="text-center"><input type="radio" id="restaurantManagementVeryGood" value="3" formControlName="restaurantManagement" /></td>
                    </tr>
                </tbody>

                




                <thead>
                    <tr>
                        <th colspan="4" class="text-center">HEALTH / MEDICAL AND FITNESS</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Medical Counseling -->
                    <tr>
                        <td >Medical Counseling</td>
                        <td class="text-center"><input type="radio" id="medicalCounselingBasic" value="1" formControlName="medicalCounseling" /></td>
                        <td class="text-center"><input type="radio" id="medicalCounselingGood" value="2" formControlName="medicalCounseling" /></td>
                        <td class="text-center"><input type="radio" id="medicalCounselingVeryGood" value="3" formControlName="medicalCounseling" /></td>
                    </tr>
                
                    <!-- Dental -->
                    <tr>
                        <td >Dental</td>
                        <td class="text-center"><input type="radio" id="dentalBasic" value="1" formControlName="dental" /></td>
                        <td class="text-center"><input type="radio" id="dentalGood" value="2" formControlName="dental" /></td>
                        <td class="text-center"><input type="radio" id="dentalVeryGood" value="3" formControlName="dental" /></td>
                    </tr>
                
                    <!-- Doctor -->
                    <tr>
                        <td >Doctor</td>
                        <td class="text-center"><input type="radio" id="doctorBasic" value="1" formControlName="doctor" /></td>
                        <td class="text-center"><input type="radio" id="doctorGood" value="2" formControlName="doctor" /></td>
                        <td class="text-center"><input type="radio" id="doctorVeryGood" value="3" formControlName="doctor" /></td>
                    </tr>
                
                    <!-- Nursing -->
                    <tr>
                        <td >Nursing</td>
                        <td class="text-center"><input type="radio" id="nursingBasic" value="1" formControlName="nursing" /></td>
                        <td class="text-center"><input type="radio" id="nursingGood" value="2" formControlName="nursing" /></td>
                        <td class="text-center"><input type="radio" id="nursingVeryGood" value="3" formControlName="nursing" /></td>
                    </tr>
                
                    <!-- Pharmacist -->
                    <tr>
                        <td >Pharmacist</td>
                        <td class="text-center"><input type="radio" id="pharmacistBasic" value="1" formControlName="pharmacist" /></td>
                        <td class="text-center"><input type="radio" id="pharmacistGood" value="2" formControlName="pharmacist" /></td>
                        <td class="text-center"><input type="radio" id="pharmacistVeryGood" value="3" formControlName="pharmacist" /></td>
                    </tr>
                
                    <!-- Therapist -->
                    <tr>
                        <td >Therapist</td>
                        <td class="text-center"><input type="radio" id="therapistBasic" value="1" formControlName="therapist" /></td>
                        <td class="text-center"><input type="radio" id="therapistGood" value="2" formControlName="therapist" /></td>
                        <td class="text-center"><input type="radio" id="therapistVeryGood" value="3" formControlName="therapist" /></td>
                    </tr>
                
                    <!-- Hatha Yoga Instructor -->
                    <tr>
                        <td >Hatha Yoga Instructor</td>
                        <td class="text-center"><input type="radio" id="hathaYogaInstructorBasic" value="1" formControlName="hathaYogaInstructor" /></td>
                        <td class="text-center"><input type="radio" id="hathaYogaInstructorGood" value="2" formControlName="hathaYogaInstructor" /></td>
                        <td class="text-center"><input type="radio" id="hathaYogaInstructorVeryGood" value="3" formControlName="hathaYogaInstructor" /></td>
                    </tr>
                </tbody>
                

                <thead>
                    <tr>
                        <th colspan="4" class="text-center">TECHNICAL SKILLS</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Audio -->
                    <tr>
                        <td >Audio</td>
                        <td class="text-center"><input type="radio" id="audioBasic" value="1" formControlName="audio" /></td>
                        <td class="text-center"><input type="radio" id="audioGood" value="2" formControlName="audio" /></td>
                        <td class="text-center"><input type="radio" id="audioVeryGood" value="3" formControlName="audio" /></td>
                    </tr>
                
                    <!-- Video -->
                    <tr>
                        <td >Video</td>
                        <td class="text-center"><input type="radio" id="videoBasic" value="1" formControlName="video" /></td>
                        <td class="text-center"><input type="radio" id="videoGood" value="2" formControlName="video" /></td>
                        <td class="text-center"><input type="radio" id="videoVeryGood" value="3" formControlName="video" /></td>
                    </tr>
                
                    <!-- Lighting -->
                    <tr>
                        <td >Lighting</td>
                        <td class="text-center"><input type="radio" id="lightingBasic" value="1" formControlName="lighting" /></td>
                        <td class="text-center"><input type="radio" id="lightingGood" value="2" formControlName="lighting" /></td>
                        <td class="text-center"><input type="radio" id="lightingVeryGood" value="3" formControlName="lighting" /></td>
                    </tr>
                
                    <!-- Drafting -->
                    <tr>
                        <td >Drafting</td>
                        <td class="text-center"><input type="radio" id="draftingBasic" value="1" formControlName="drafting" /></td>
                        <td class="text-center"><input type="radio" id="draftingGood" value="2" formControlName="drafting" /></td>
                        <td class="text-center"><input type="radio" id="draftingVeryGood" value="3" formControlName="drafting" /></td>
                    </tr>
                
                    <!-- Electronics -->
                    <tr>
                        <td >Electronics</td>
                        <td class="text-center"><input type="radio" id="electronicsBasic" value="1" formControlName="electronics" /></td>
                        <td class="text-center"><input type="radio" id="electronicsGood" value="2" formControlName="electronics" /></td>
                        <td class="text-center"><input type="radio" id="electronicsVeryGood" value="3" formControlName="electronics" /></td>
                    </tr>
                
                    <!-- Mechanic -->
                    <tr>
                        <td >Mechanic</td>
                        <td class="text-center"><input type="radio" id="mechanicBasic" value="1" formControlName="mechanic" /></td>
                        <td class="text-center"><input type="radio" id="mechanicGood" value="2" formControlName="mechanic" /></td>
                        <td class="text-center"><input type="radio" id="mechanicVeryGood" value="3" formControlName="mechanic" /></td>
                    </tr>
                
                    <!-- Telecommunications -->
                    <tr>
                        <td>Telecommunications</td>
                        <td class="text-center"><input type="radio" id="telecommunicationsBasic" value="1" formControlName="telecommunications" /></td>
                        <td class="text-center"><input type="radio" id="telecommunicationsGood" value="2" formControlName="telecommunications" /></td>
                        <td class="text-center"><input type="radio" id="telecommunicationsVeryGood" value="3" formControlName="telecommunications" /></td>
                    </tr>
                </tbody>
                


              <thead> <tr> <th colspan="4" class="text-center">LANGUAGE AND COMMUNICATION</th></tr></thead>
              <tbody>
                <!-- Journalism -->
    <tr>
        <td >Journalism</td>
        <td class="text-center"><input type="radio" id="journalismBasic" value="1" formControlName="journalism" /></td>
        <td class="text-center"><input type="radio" id="journalismGood" value="2" formControlName="journalism" /></td>
        <td class="text-center"><input type="radio" id="journalismVeryGood" value="3" formControlName="journalism" /></td>
      </tr>
  
      <!-- Hindi Typing -->
      <tr>
        <td >Hindi Typing</td>
        <td class="text-center"><input type="radio" id="hindiTypingBasic" value="1" formControlName="hindiTyping" /></td>
        <td class="text-center"><input type="radio" id="hindiTypingGood" value="2" formControlName="hindiTyping" /></td>
        <td class="text-center"><input type="radio" id="hindiTypingVeryGood" value="3" formControlName="hindiTyping" /></td>
      </tr>
  
      <!-- Shvetambari Typing -->
      <tr>
        <td >Shvetambari Typing</td>
        <td class="text-center"><input type="radio" id="shvetambariTypingBasic" value="1" formControlName="shvetambariTyping" /></td>
        <td class="text-center"><input type="radio" id="shvetambariTypingGood" value="2" formControlName="shvetambariTyping" /></td>
        <td class="text-center"><input type="radio" id="shvetambariTypingVeryGood" value="3" formControlName="shvetambariTyping" /></td>
      </tr>
  
      <!-- Other Languages Typing -->
      <tr>
        <td >Other Languages Typing (Specify)</td>
        <td class="text-center"><input type="radio" id="otherLanguagesTypingBasic" value="1" formControlName="otherLanguagesTyping" /></td>
        <td class="text-center"><input type="radio" id="otherLanguagesTypingGood" value="2" formControlName="otherLanguagesTyping" /></td>
        <td class="text-center"><input type="radio" id="otherLanguagesTypingVeryGood" value="3" formControlName="otherLanguagesTyping" /></td>
      </tr>
  
      <!-- Proofreading / Editing -->
      <tr>
        <td >Proofreading / Editing (Specify Language)</td>
        <td class="text-center"><input type="radio" id="proofreadingBasic" value="1" formControlName="proofreading" /></td>
        <td class="text-center"><input type="radio" id="proofreadingGood" value="2" formControlName="proofreading" /></td>
        <td class="text-center"><input type="radio" id="proofreadingVeryGood" value="3" formControlName="proofreading" /></td>
      </tr>
  
      <!-- Public Speaking / Presenting -->
      <tr>
        <td>Public Speaking / Presenting</td>
        <td class="text-center"><input type="radio" id="publicSpeakingBasic" value="1" formControlName="publicSpeaking" /></td>
        <td class="text-center"><input type="radio" id="publicSpeakingGood" value="2" formControlName="publicSpeaking" /></td>
        <td class="text-center"><input type="radio" id="publicSpeakingVeryGood" value="3" formControlName="publicSpeaking" /></td>
      </tr>
  
      <!-- Fluent Translation -->
      <tr>
        <td >Fluent Translation (Specify Languages)</td>
        <td class="text-center"><input type="radio" id="fluentTranslationBasic" value="1" formControlName="fluentTranslation" /></td>
        <td class="text-center"><input type="radio" id="fluentTranslationGood" value="2" formControlName="fluentTranslation" /></td>
        <td class="text-center"><input type="radio" id="fluentTranslationVeryGood" value="3" formControlName="fluentTranslation" /></td>
      </tr>
  
      <!-- Note-Taking / Minute-Taking -->
      <tr>
        <td >Note-Taking / Minute-Taking</td>
        <td class="text-center"><input type="radio" id="noteTakingBasic" value="1" formControlName="noteTaking" /></td>
        <td class="text-center"><input type="radio" id="noteTakingGood" value="2" formControlName="noteTaking" /></td>
        <td class="text-center"><input type="radio" id="noteTakingVeryGood" value="3" formControlName="noteTaking" /></td>
      </tr>
              </tbody>



              <thead>
                <tr>
                    <th colspan="4" class="text-center">OTHER SKILLS & SERVICES</th>
                </tr>
            </thead>
            <tbody>
                <!-- Animal Care -->
                <tr>
                    <td >Animal Care</td>
                    <td class="text-center"><input type="radio" id="animalCareBasic" value="1" formControlName="animalCare" /></td>
                    <td class="text-center"><input type="radio" id="animalCareGood" value="2" formControlName="animalCare" /></td>
                    <td class="text-center"><input type="radio" id="animalCareVeryGood" value="3" formControlName="animalCare" /></td>
                </tr>
            
                <!-- Child Care -->
                <tr>
                    <td >Child Care</td>
                    <td class="text-center"><input type="radio" id="childCareBasic" value="1" formControlName="childCare" /></td>
                    <td class="text-center"><input type="radio" id="childCareGood" value="2" formControlName="childCare" /></td>
                    <td class="text-center"><input type="radio" id="childCareVeryGood" value="3" formControlName="childCare" /></td>
                </tr>
            
                <!-- Cleaning -->
                <tr>
                    <td >Cleaning</td>
                    <td class="text-center"><input type="radio" id="cleaningBasic" value="1" formControlName="cleaning" /></td>
                    <td class="text-center"><input type="radio" id="cleaningGood" value="2" formControlName="cleaning" /></td>
                    <td class="text-center"><input type="radio" id="cleaningVeryGood" value="3" formControlName="cleaning" /></td>
                </tr>
            
                <!-- Education / Teaching -->
                <tr>
                    <td >Education / Teaching</td>
                    <td class="text-center"><input type="radio" id="educationTeachingBasic" value="1" formControlName="educationTeaching" /></td>
                    <td class="text-center"><input type="radio" id="educationTeachingGood" value="2" formControlName="educationTeaching" /></td>
                    <td class="text-center"><input type="radio" id="educationTeachingVeryGood" value="3" formControlName="educationTeaching" /></td>
                </tr>
            
                <!-- Gardening -->
                <tr>
                    <td >Gardening</td>
                    <td class="text-center"><input type="radio" id="gardeningBasic" value="1" formControlName="gardening" /></td>
                    <td class="text-center"><input type="radio" id="gardeningGood" value="2" formControlName="gardening" /></td>
                    <td class="text-center"><input type="radio" id="gardeningVeryGood" value="3" formControlName="gardening" /></td>
                </tr>
            
                <!-- Horticulture -->
                <tr>
                    <td >Horticulture</td>
                    <td class="text-center"><input type="radio" id="horticultureBasic" value="1" formControlName="horticulture" /></td>
                    <td class="text-center"><input type="radio" id="horticultureGood" value="2" formControlName="horticulture" /></td>
                    <td class="text-center"><input type="radio" id="horticultureVeryGood" value="3" formControlName="horticulture" /></td>
                </tr>
            
                <!-- Agriculture -->
                <tr>
                    <td >Agriculture</td>
                    <td class="text-center"><input type="radio" id="agricultureBasic" value="1" formControlName="agriculture" /></td>
                    <td class="text-center"><input type="radio" id="agricultureGood" value="2" formControlName="agriculture" /></td>
                    <td class="text-center"><input type="radio" id="agricultureVeryGood" value="3" formControlName="agriculture" /></td>
                </tr>
            
                <!-- Military / Security -->
                <tr>
                    <td >Military / Security</td>
                    <td class="text-center"><input type="radio" id="militarySecurityBasic" value="1" formControlName="militarySecurity" /></td>
                    <td class="text-center"><input type="radio" id="militarySecurityGood" value="2" formControlName="militarySecurity" /></td>
                    <td class="text-center"><input type="radio" id="militarySecurityVeryGood" value="3" formControlName="militarySecurity" /></td>
                </tr>
            </tbody>




            <thead>
                <tr>
                    <th colspan="4" class="text-center">SIDDHA YOGA TRAINING</th>
                </tr>
            </thead>
            <tbody>
                <!-- Meditation Teacher -->
                <tr>
                    <td >Meditation Teacher</td>
                    <td class="text-center"><input type="radio" id="meditationTeacherBasic" value="1" formControlName="meditationTeacher" /></td>
                    <td class="text-center"><input type="radio" id="meditationTeacherGood" value="2" formControlName="meditationTeacher" /></td>
                    <td class="text-center"><input type="radio" id="meditationTeacherVeryGood" value="3" formControlName="meditationTeacher" /></td>
                </tr>
            
                <!-- Siddha Yoga Facilitator -->
                <tr>
                    <td >Siddha Yoga Facilitator</td>
                    <td class="text-center"><input type="radio" id="siddhaYogaFacilitatorBasic" value="1" formControlName="siddhaYogaFacilitator" /></td>
                    <td class="text-center"><input type="radio" id="siddhaYogaFacilitatorGood" value="2" formControlName="siddhaYogaFacilitator" /></td>
                    <td class="text-center"><input type="radio" id="siddhaYogaFacilitatorVeryGood" value="3" formControlName="siddhaYogaFacilitator" /></td>
                </tr>
            
                <!-- Content Development -->
                <tr>
                    <td >Content Development</td>
                    <td class="text-center"><input type="radio" id="contentDevelopmentBasic" value="1" formControlName="contentDevelopment" /></td>
                    <td class="text-center"><input type="radio" id="contentDevelopmentGood" value="2" formControlName="contentDevelopment" /></td>
                    <td class="text-center"><input type="radio" id="contentDevelopmentVeryGood" value="3" formControlName="contentDevelopment" /></td>
                </tr>
            
                <!-- Event Planning -->
                <tr>
                    <td >Event Planning</td>
                    <td class="text-center"><input type="radio" id="eventPlanningBasic" value="1" formControlName="eventPlanning" /></td>
                    <td class="text-center"><input type="radio" id="eventPlanningGood" value="2" formControlName="eventPlanning" /></td>
                    <td class="text-center"><input type="radio" id="eventPlanningVeryGood" value="3" formControlName="eventPlanning" /></td>
                </tr>
            
                <!-- Other (Optional) -->
                <tr>
                    <td class="text-center">Other</td>
                    <td colspan="3"><input type="text" formControlName="other" placeholder="Specify other skills or services" /></td>
                </tr>
            </tbody>

            


            <thead>
                <tr>
                    <th colspan="4" class="text-center">GENERAL ABILITIES</th>
                </tr>
            </thead>
            <tbody>
                <!-- Active Listening -->
                <tr>
                    <td >Active Listening</td>
                    <td class="text-center"><input type="radio" id="activeListeningBasic" value="1" formControlName="activeListening" /></td>
                    <td class="text-center"><input type="radio" id="activeListeningGood" value="2" formControlName="activeListening" /></td>
                    <td class="text-center"><input type="radio" id="activeListeningVeryGood" value="3" formControlName="activeListening" /></td>
                </tr>
            
                <!-- Creative Problem Solving -->
                <tr>
                    <td>Creative Problem Solving</td>
                    <td class="text-center"><input type="radio" id="creativeProblemSolvingBasic" value="1" formControlName="creativeProblemSolving" /></td>
                    <td class="text-center"><input type="radio" id="creativeProblemSolvingGood" value="2" formControlName="creativeProblemSolving" /></td>
                    <td class="text-center"><input type="radio" id="creativeProblemSolvingVeryGood" value="3" formControlName="creativeProblemSolving" /></td>
                </tr>
            
                <!-- Team Working -->
                <tr>
                    <td >Team Working</td>
                    <td class="text-center"><input type="radio" id="teamWorkingBasic" value="1" formControlName="teamWorking" /></td>
                    <td class="text-center"><input type="radio" id="teamWorkingGood" value="2" formControlName="teamWorking" /></td>
                    <td class="text-center"><input type="radio" id="teamWorkingVeryGood" value="3" formControlName="teamWorking" /></td>
                </tr>
            
                <!-- Reliability -->
                <tr>
                    <td >Reliability</td>
                    <td class="text-center"><input type="radio" id="reliabilityBasic" value="1" formControlName="reliability" /></td>
                    <td class="text-center"><input type="radio" id="reliabilityGood" value="2" formControlName="reliability" /></td>
                    <td class="text-center"><input type="radio" id="reliabilityVeryGood" value="3" formControlName="reliability" /></td>
                </tr>
            
                <!-- Flexibility to Change -->
                <tr>
                    <td >Flexibility to Change</td>
                    <td class="text-center"><input type="radio" id="flexibilityToChangeBasic" value="1" formControlName="flexibilityToChange" /></td>
                    <td class="text-center"><input type="radio" id="flexibilityToChangeGood" value="2" formControlName="flexibilityToChange" /></td>
                    <td class="text-center"><input type="radio" id="flexibilityToChangeVeryGood" value="3" formControlName="flexibilityToChange" /></td>
                </tr>
            
                <!-- Leadership -->
                <tr>
                    <td >Leadership</td>
                    <td class="text-center"><input type="radio" id="leadershipBasic" value="1" formControlName="leadership" /></td>
                    <td class="text-center"><input type="radio" id="leadershipGood" value="2" formControlName="leadership" /></td>
                    <td class="text-center"><input type="radio" id="leadershipVeryGood" value="3" formControlName="leadership" /></td>
                </tr>
            
                <!-- Proactivity -->
                <tr>
                    <td >Proactivity</td>
                    <td class="text-center"><input type="radio" id="proactivityBasic" value="1" formControlName="proactivity" /></td>
                    <td class="text-center"><input type="radio" id="proactivityGood" value="2" formControlName="proactivity" /></td>
                    <td class="text-center"><input type="radio" id="proactivityVeryGood" value="3" formControlName="proactivity" /></td>
                </tr>
            
                <!-- Critical Thinking -->
                <tr>
                    <td >Critical Thinking</td>
                    <td class="text-center"><input type="radio" id="criticalThinkingBasic" value="1" formControlName="criticalThinking" /></td>
                    <td class="text-center"><input type="radio" id="criticalThinkingGood" value="2" formControlName="criticalThinking" /></td>
                    <td class="text-center"><input type="radio" id="criticalThinkingVeryGood" value="3" formControlName="criticalThinking" /></td>
                </tr>
            
                <!-- Communicating Clearly -->
                <tr>
                    <td >Communicating Clearly</td>
                    <td class="text-center"><input type="radio" id="communicatingClearlyBasic" value="1" formControlName="communicatingClearly" /></td>
                    <td class="text-center"><input type="radio" id="communicatingClearlyGood" value="2" formControlName="communicatingClearly" /></td>
                    <td class="text-center"><input type="radio" id="communicatingClearlyVeryGood" value="3" formControlName="communicatingClearly" /></td>
                </tr>
            
                <!-- Willingness to Learn -->
                <tr>
                    <td >Willingness to Learn</td>
                    <td class="text-center"><input type="radio" id="willingnessToLearnBasic" value="1" formControlName="willingnessToLearn" /></td>
                    <td class="text-center"><input type="radio" id="willingnessToLearnGood" value="2" formControlName="willingnessToLearn" /></td>
                    <td class="text-center"><input type="radio" id="willingnessToLearnVeryGood" value="3" formControlName="willingnessToLearn" /></td>
                </tr>
            
                <!-- Working Alone -->
                <tr>
                    <td >Working Alone</td>
                    <td class="text-center"><input type="radio" id="workingAloneBasic" value="1" formControlName="workingAlone" /></td>
                    <td class="text-center"><input type="radio" id="workingAloneGood" value="2" formControlName="workingAlone" /></td>
                    <td class="text-center"><input type="radio" id="workingAloneVeryGood" value="3" formControlName="workingAlone" /></td>
                </tr>
            
                <!-- Interpersonal Skills -->
                <tr>
                    <td >Interpersonal Skills</td>
                    <td class="text-center"><input type="radio" id="interpersonalSkillsBasic" value="1" formControlName="interpersonalSkills" /></td>
                    <td class="text-center"><input type="radio" id="interpersonalSkillsGood" value="2" formControlName="interpersonalSkills" /></td>
                    <td class="text-center"><input type="radio" id="interpersonalSkillsVeryGood" value="3" formControlName="interpersonalSkills" /></td>
                </tr>
            
                <!-- Patience -->
                <tr>
                    <td >Patience</td>
                    <td class="text-center"><input type="radio" id="patienceBasic" value="1" formControlName="patience" /></td>
                    <td class="text-center"><input type="radio" id="patienceGood" value="2" formControlName="patience" /></td>
                    <td class="text-center"><input type="radio" id="patienceVeryGood" value="3" formControlName="patience" /></td>
                </tr>
            
                <!-- Detail Orientation -->
                <tr>
                    <td >Detail Orientation</td>
                    <td class="text-center"><input type="radio" id="detailOrientationBasic" value="1" formControlName="detailOrientation" /></td>
                    <td class="text-center"><input type="radio" id="detailOrientationGood" value="2" formControlName="detailOrientation" /></td>
                    <td class="text-center"><input type="radio" id="detailOrientationVeryGood" value="3" formControlName="detailOrientation" /></td>
                </tr>
            
                <!-- Giving Feedback -->
                <tr>
                    <td >Giving Feedback</td>
                    <td class="text-center"><input type="radio" id="givingFeedbackBasic" value="1" formControlName="givingFeedback" /></td>
                    <td class="text-center"><input type="radio" id="givingFeedbackGood" value="2" formControlName="givingFeedback" /></td>
                    <td class="text-center"><input type="radio" id="givingFeedbackVeryGood" value="3" formControlName="givingFeedback" /></td>
                </tr>
            
                <!-- Receiving Feedback -->
                <tr>
                    <td >Receiving Feedback</td>
                    <td class="text-center"><input type="radio" id="receivingFeedbackBasic" value="1" formControlName="receivingFeedback" /></td>
                    <td class="text-center"><input type="radio" id="receivingFeedbackGood" value="2" formControlName="receivingFeedback" /></td>
                    <td class="text-center"><input type="radio" id="receivingFeedbackVeryGood" value="3" formControlName="receivingFeedback" /></td>
                </tr>
            
                <!-- Respecting Confidentiality -->
                <tr>
                    <td >Respecting Confidentiality</td>
                    <td class="text-center"><input type="radio" id="respectingConfidentialityBasic" value="1" formControlName="respectingConfidentiality" /></td>
                    <td class="text-center"><input type="radio" id="respectingConfidentialityGood" value="2" formControlName="respectingConfidentiality" /></td>
                    <td class="text-center"><input type="radio" id="respectingConfidentialityVeryGood" value="3" formControlName="respectingConfidentiality" /></td>
                </tr>
            
                <!-- Calmness in Difficult Situations -->
                <tr>
                    <td>Calmness in Difficult Situations</td>
                    <td class="text-center"><input type="radio" id="calmnessInDifficultSituationsBasic" value="1" formControlName="calmnessInDifficultSituations" /></td>
                    <td class="text-center"><input type="radio" id="calmnessInDifficultSituationsGood" value="2" formControlName="calmnessInDifficultSituations" /></td>
                    <td class="text-center"><input type="radio" id="calmnessInDifficultSituationsVeryGood" value="3" formControlName="calmnessInDifficultSituations" /></td>
                </tr>
            
                <!-- Sharing Knowledge -->
                <tr>
                    <td >Sharing Knowledge</td>
                    <td class="text-center"><input type="radio" id="sharingKnowledgeBasic" value="1" formControlName="sharingKnowledge" /></td>
                    <td class="text-center"><input type="radio" id="sharingKnowledgeGood" value="2" formControlName="sharingKnowledge" /></td>
                    <td class="text-center"><input type="radio" id="sharingKnowledgeVeryGood" value="3" formControlName="sharingKnowledge" /></td>
                </tr>
            
                <!-- Creative Ability -->
                <tr>
                    <td >Creative Ability</td>
                    <td class="text-center"><input type="radio" id="creativeAbilityBasic" value="1" formControlName="creativeAbility" /></td>
                    <td class="text-center"><input type="radio" id="creativeAbilityGood" value="2" formControlName="creativeAbility" /></td>
                    <td class="text-center"><input type="radio" id="creativeAbilityVeryGood" value="3" formControlName="creativeAbility" /></td>
                </tr>
            
                <!-- Numerical Ability -->
                <tr>
                    <td >Numerical Ability</td>
                    <td class="text-center"><input type="radio" id="numericalAbilityBasic" value="1" formControlName="numericalAbility" /></td>
                    <td class="text-center"><input type="radio" id="numericalAbilityGood" value="2" formControlName="numericalAbility" /></td>
                    <td class="text-center"><input type="radio" id="numericalAbilityVeryGood" value="3" formControlName="numericalAbility" /></td>
                </tr>
            
                <!-- Physical Ability -->
                <tr>
                    <td >Physical Ability</td>
                    <td class="text-center"><input type="radio" id="physicalAbilityBasic" value="1" formControlName="physicalAbility" /></td>
                    <td class="text-center"><input type="radio" id="physicalAbilityGood" value="2" formControlName="physicalAbility" /></td>
                    <td class="text-center"><input type="radio" id="physicalAbilityVeryGood" value="3" formControlName="physicalAbility" /></td>
                </tr>
            </tbody>
            
        
             

            </table>
          </div>
          

        <!-- Buttons -->
        <div class="d-flex justify-content-between">
            <button class="btn savedraftbtn" type="button">SAVE AS DRAFT</button>
            <div>
                <button type="button" class="prevbtn" (click)="goToBack()">PREVIOUS</button>
                <button type="submit" class="nextbtn">NEXT</button>
            </div>
        </div>
    </div>
</form>